(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2381],{

/***/ 502:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/kyb-workflow-automation",
      function () {
        return __webpack_require__(15925);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55123:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Acuris.0680843c.png","height":120,"width":247,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////7+Pj////T09Pk39/16Onvt73jsbl+6eYYAAAAAnRSTlP7/ULXe+8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAjSURBVHicJcnBDQAgDMSwlFxh/42RWn/NWVC3TQL9oloAUx8GCgBPMJbqSgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 67638:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Creditsafe.99193bc8.png","height":50,"width":252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEXlNy7kOi7jOCzkOSriODF4s487AAAABXRSTlM0FU4/JO/U0X0AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BkZGFgZGZmYmBgYGZmYmJiBAABCQAdVm2urQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 90887:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Equifax.f41cfa8b.png","height":40,"width":205,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEWzJUCzJUCyJECyJECxJUGxJD+yJT+yJj6zJEC3JUMg3OPaAAAACnRSTlOkSleCbTiQNYqyhh2xIwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxj4GRg5mBgY2BhYGJkZmJkZWIHAAIJADZTrDwDAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 88307:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Experian.bdd3a34e.png","height":80,"width":241,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUUZogdSYsmRYsqRowlRYxQVp8mRYuXNYRlKnz6ipDiAAAACXRSTlMDGAtjVVs4MnFlJc0fAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVR4nAXBgQEAAATDsM4w/18sYQYo4Ozu9ZJIKvEDugBG5eX2XQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 5546:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Nominodata.ea76493a.png","height":60,"width":159,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJ1BMVEX5+v3+4tnz1s9UYZS7vM6Oqczx3dn/7eNXTnJnapXKy9v+7OZFd6qJfi2dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVR4nGNg5WFhZ2Rk5GZg5mBmZGJiYmNg4eRiAAEABecAXV/0Q/UAAAAASUVORK5CYII="});

/***/ }),

/***/ 74768:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/OpenCorporates.8b0a3dca.png","height":40,"width":191,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEXu6ery8/Pi4+P38PHt2Nzd2drv5Oanw8o/AAAAAnRSTlPu7vHc3CUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVHicY2BmYWNiYmJiZAAxWJlYGQAB0wAy8TWB8gAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 5477:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/SayariLabs.f50b3e99.png","height":824,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUAGyMAAAAAAQEAAAAAjccABwcAtPcARV02Zsk4AAAACHRSTlMGDVQ6GCNIXwAD3oEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAfSURBVHicFcGHDQAwDMMwyVn/f1yUBJCvktrLoNotDwHvAC33+rAtAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 15925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ kyb_workflow_automation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/TitleSection.jsx
var TitleSection = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/DataPartners.jsx
var DataPartners = __webpack_require__(83570);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Resources.jsx + 1 modules
var Resources = __webpack_require__(82558);
// EXTERNAL MODULE: ./src/landingPage/datasets/usecases/kyb.js + 6 modules
var kyb = __webpack_require__(58602);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Recipes.jsx + 1 modules
var Recipes = __webpack_require__(41974);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/KYB/KYB.jsx







// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";
var KYB = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "kyb_landing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection/* default */.Z, {
                data: kyb/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Recipes/* default */.Z, {
                data: kyb/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataPartners/* default */.Z, {
                dataPartners: kyb/* default.dataPartners */.Z.dataPartners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Resources/* default */.Z, (0,_object_spread/* default */.Z)({}, kyb/* default */.Z))
        ]
    });
};

;// CONCATENATED MODULE: ./pages/use-cases/kyb-workflow-automation.jsx




var KybPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/use-cases/kyb-workflow-automation",
                title: meta/* meta.usecases.kyb.title */.$.usecases.kyb.title,
                description: meta/* meta.usecases.kyb.description */.$.usecases.kyb.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KYB, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var kyb_workflow_automation = (KybPage);


/***/ }),

/***/ 58602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ kyb; }
});

;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Bureau_van_Dijk.png
/* harmony default export */ var Bureau_van_Dijk = ({"src":"/_next/static/media/Bureau_van_Dijk.aa14e80a.png","height":433,"width":601,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJFBMVEWgoHsJGIpkbYwxP4yUmI0AEIUSI4sAC4iTlY2EiY0DGYlOWIsos8nkAAAADHRSTlMCICoMhC559mHOUOH9yv1gAAAACXBIWXMAAC7gAAAu4AEPDtfhAAAAKUlEQVR4nCXJyQ0AIACEQHC97b9fE50XCYBNnj1O/dXXBKJRQ8qTP4ELC6EAX6Ja5+8AAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Equifax.png
var Equifax = __webpack_require__(90887);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Acuris.png
var Acuris = __webpack_require__(55123);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Experian.png
var Experian = __webpack_require__(88307);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/OpenCorporates.png
var OpenCorporates = __webpack_require__(74768);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/creditorwatch.png
/* harmony default export */ var creditorwatch = ({"src":"/_next/static/media/creditorwatch.51bb0971.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX////v7+/pvMHjrbL15ufx2dvQ0ND99/jEw8Pc3d3fmJ91cEwMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nGXLNwEAMAwDMI/M8gdcANEv4MiIVETCkp8tNLlbbIAzVbwHHxLAAIU1MEMtAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Creditsafe.png
var Creditsafe = __webpack_require__(67638);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Nominodata.png
var Nominodata = __webpack_require__(5546);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/AustralianBusinessRegister.png
/* harmony default export */ var AustralianBusinessRegister = ({"src":"/_next/static/media/AustralianBusinessRegister.2cc62ea9.png","height":104,"width":483,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEXLy8vT09Pn5+ft7e20tLTl5eXExMT6+vqje0jNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYGFmZWJmZWdgY2FlYGBkYAQAAe4AL+X9tjcAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/SayariLabs.png
var SayariLabs = __webpack_require__(5477);
;// CONCATENATED MODULE: ./src/landingPage/assets/resource-images/business_firmographics_for_us_kyb.png
/* harmony default export */ var business_firmographics_for_us_kyb = ({"src":"/_next/static/media/business_firmographics_for_us_kyb.adcc38bd.png","height":420,"width":760,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEXz8vOMkpH5+fnq6uyysLLn5ei1tLWan5+3t7iZn57FNs6cAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJElEQVR4nAXBhwEAIAzDMGe0wP8PI1HpPEkE37WBeAvQCSTzAQaMAFcS29kLAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/landingPage/assets/resource-images/business_registration_and_linked_company_details_for_global_kyb.png
/* harmony default export */ var business_registration_and_linked_company_details_for_global_kyb = ({"src":"/_next/static/media/business_registration_and_linked_company_details_for_global_kyb.4153e238.png","height":424,"width":762,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAALVBMVEXi4uLz8/br7O75+fmEi4q1tbWTmJinnM96foTGwN68vb3V19WnqrGvnpDn5+q/Ks2ZAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJklEQVR4nAXBhwEAMAzDINkZ3f+/W+B2dmdOLFXFGsixKyTewQY+C0cAim3F1wsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/resource-images/consumer_watchlist_fraud_screening.png
/* harmony default export */ var consumer_watchlist_fraud_screening = ({"src":"/_next/static/media/consumer_watchlist_fraud_screening.099c48ca.png","height":424,"width":762,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJ1BMVEXh4eT8/f3q6ezx8vG3t7eRlpaFi4uqpabe2uh5foFoa3mvr6/z8vcmUUvuAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJklEQVR4nAXBhwEAMAzDINlZXf/fW2Cqq3of7MgbLF4oUxIDDswHC1IAgCu0dv0AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/datasets/usecases/kyb.js













var data = {
    usecaseInfo: {
        name: "KYB Workflow Automation",
        description: "A single platform for seamless onboarding and verification of businesses globally."
    },
    recipesInfo: {
        title: "Onboard businesses in seconds",
        description: "Access API-ready solutions for business registry verification, director and ultimate benefit ownership identification, global anti-money laundering (AML) and watchlist screening, politically exposed persons (PEP) screening, negative news screening, and digital presence assessment, among many others."
    },
    recipes: [
        {
            type: "Business Data",
            title: "Business Registration and Ownership Information",
            description: "Check for a business' registration and linked companies such as parents, UBOs, subsidiaries and more.",
            url: "/app/data-catalog/recipes?all=false&data_source=&direction=&page=1&search=registration&sort=&tags[]=KYB%20Workflow%20Automation"
        },
        {
            type: "Business Data",
            title: "Business Firmographics",
            description: "Identify industry codes, annual sales revenue, number of employees, business start year, and contact details.",
            url: "/app/recipe/2/business-firmographics-for-us-kyb-onboarding-and-marketing"
        },
        {
            type: "Business Data",
            title: "Domain checks for Business Digital Presence",
            description: "Validate and identify a business and its pertinent information from a supplied business domain.",
            url: "/app/recipe/43/business-firmographics-from-domain-for-kyb-onboarding-marketing"
        },
        {
            type: "Business Data",
            title: "Judgement Counts",
            description: "Assess the financial health of a business by examining raw judgments data.",
            url: "/app/recipe/3/business-judgment-counts-for-us-kyb-and-onboarding"
        },
        {
            type: "Business Data",
            title: "Watchlist and Fraud screening",
            description: "Check for business presence on any relevant watchlists such as sanctions, PEP, adverse media, and more.",
            url: "/app/recipe/56/business-watchlist-and-fraud-screening"
        },
        {
            type: "Other Data",
            title: "...And Many More",
            description: "Access all of our KYB api-ready recipes now.",
            ctaText: "Access Recipe Catalog",
            url: "/app/data-catalog/recipes?page=1&tags[]=KYB%20Workflow%20Automation"
        }, 
    ],
    dataPartners: {
        title: "Sample Data Providers",
        description: "Access to hundreds of data partners worldwide",
        logos: [
            {
                name: "AustralianBusinessRegister",
                img: AustralianBusinessRegister
            },
            {
                name: "Equifax",
                img: Equifax/* default */.Z
            },
            {
                name: "Bureau van Dijk (BvD)",
                img: Bureau_van_Dijk
            },
            {
                name: "Acuris",
                img: Acuris/* default */.Z
            },
            {
                name: "CreditorWatch",
                img: creditorwatch
            },
            {
                name: "Experian",
                img: Experian/* default */.Z
            },
            {
                name: "Sayari Labs",
                img: SayariLabs/* default */.Z
            },
            {
                name: "OpenCorporates",
                img: OpenCorporates/* default */.Z
            },
            {
                name: "CreditSafe",
                img: Creditsafe/* default */.Z
            },
            {
                name: "Nomino Data",
                img: Nominodata/* default */.Z
            }, 
        ]
    },
    resourcesInfo: {
        title: "Resources",
        description: "The latest news, technologies, and resources from our team."
    },
    resources: [
        {
            title: "5 Checks For Flagging Fraud Risk",
            url: "https://demyst.com/blog/5-checks-for-flagging-fraud-risk",
            featured_image: "https://cdn.buttercms.com/DRlPxD3RTbyFaP0LERTt",
            date: "2022-04-20",
            description: "Paypal’s recent discovery of 4.5 million illegitimate accounts on its platform should be a warning heeded by all: even the largest, most sophisticated payment processors can fall victim to bad actors. An effective ID verification process considers 5 data points: ",
            more: ""
        },
        {
            title: "Digital Footprints for ID Verification",
            url: "https://demyst.com/blog/digital-footprints-for-id-verification",
            featured_image: "https://cdn.buttercms.com/bez6PhOGT5KMUdsTQKIC",
            date: "2022-02-03",
            description: "Demyst spoke with Gergő Varga, product evangelist at Seon, to discuss how external data can be used to go beyond basic anti-fraud checks. Varga explained how an individual’s online record of activity can be used like a digital footprint, which offers a more comprehensive approach to confirming identities.",
            more: ""
        },
        {
            title: "Global IDV Workflows Demand Multi Source Solutions",
            url: "https://demyst.com/blog/digital-id-verification-a-multi-source-solution",
            featured_image: "https://cdn.buttercms.com/i3HoaJZxSsQ91PGkEonW",
            date: "2022-01-28",
            description: "Across the world, financial institutions (FIs) are struggling to optimize customer onboarding processes while maintaining sufficient controls for risk, fraud, and identity verification (IDV). This pressure is exacerbated by incomplete data products, data markets that vary in maturity (certain markets have near 100% coverage in identity while others are much more nascent), and a strong desire for innovation.",
            more: ""
        },
        {
            title: "Consumer Watchlist and Fraud Screening",
            url: "https://www.youtube.com/watch?v=SI7nO_VT4FY",
            featured_image: consumer_watchlist_fraud_screening.src,
            date: "2022-03-18",
            description: "A regulated financial services firm has obligations to conduct know-your-customer (KYC) checks on consumers that it wishes to do business with. This involves confirming that a customer is who they say they are in order to reduce fraud and other bad-actor risks. You can use this recipe to establish an automated process that can flag for relevant risks in real-time, reducing manual reviews to only those that require it and providing a more seamless customer experience.",
            more: ""
        },
        {
            title: "Business Firmographics for US KYB",
            url: "https://youtu.be/tAOqrNejBgY",
            featured_image: business_firmographics_for_us_kyb.src,
            date: "2022-05-5",
            description: "When using this recipe, provide the registered name of the business and its address to retrieve available business firmographics (such as SIC and NAICS codes, website, phone number, and business age) along with financial performance metrics (such as number of employees and sales).",
            more: ""
        },
        {
            title: "Business Registration and Linked Company Details for Global KYB",
            url: "https://www.youtube.com/watch?v=VklaR6XfB2w",
            featured_image: business_registration_and_linked_company_details_for_global_kyb.src,
            date: "2022-06-2",
            description: "Use this recipe as part of a know-your-business (KYB) workflow outside the US to gather key information all in a centralized place, ready for an automated approval workflow or a simplified review process. When using this recipe, input a business' name and country, and it will return a business' registration for the most likely matched business based off the inputs, and also revert shareholder, parent company, subsidiary and ultimate beneficial owner details if they are available.",
            more: ""
        }, 
    ]
};
/* harmony default export */ var kyb = (data);


/***/ }),

/***/ 82558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Resources; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 14 modules
var format = __webpack_require__(4758);
// EXTERNAL MODULE: ./src/landingPage/assets/demyst_meta_image.png
var demyst_meta_image = __webpack_require__(34631);
;// CONCATENATED MODULE: ./src/landingPage/views/components/HighlightCard.jsx




/* harmony default export */ var HighlightCard = (/*#__PURE__*/react.forwardRef(function(param, ref) {
    var title = param.title, url = param.url, featured_image = param.featured_image, date = param.date, description = param.description, more = param.more;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: "highlight-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-card-image",
                    style: {
                        backgroundImage: "url(".concat(featured_image || demyst_meta_image/* default */.Z, ")")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-card-cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "highlight-card-textarea",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "highlight-card-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-description",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-date",
                            children: (0,format/* default */.Z)(new Date(date), "LLLL dd, yyyy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-more",
                            children: more
                        })
                    ]
                })
            ]
        })
    }, title);
}));

// EXTERNAL MODULE: ./src/landingPage/views/components/Slider.jsx + 1 modules
var Slider = __webpack_require__(96777);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/components/Resources.jsx





var Resources = function(param) {
    var resources = param.resources, resourcesInfo = param.resourcesInfo;
    var card = (0,react.useRef)(null);
    var ref = (0,react.useState)(), stepSize = ref[0], setStepSize = ref[1];
    (0,react.useEffect)(function() {
        var offsetWidth = card.current.offsetWidth;
        setStepSize(offsetWidth);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "usecases_resources_section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "usecases_resources_section-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: resourcesInfo.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "usecases_resources_section-subtitle",
                    children: resourcesInfo.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                    stepSize: stepSize,
                    children: resources.map(function(resource) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCard, (0,_object_spread/* default */.Z)({
                            ref: card
                        }, resource), resource.url);
                    })
                })
            ]
        })
    });
};
Resources.defaultProps = {
    resources: [],
    resourcesInfo: {}
};
/* harmony default export */ var components_Resources = (Resources);


/***/ }),

/***/ 38828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11723);



/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "usecases_title_section",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "usecases_title_section-container section-layout",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "usecases_title_section-text_container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: data.usecaseInfo.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "usecases_title_section-description",
                            children: data.usecaseInfo.description
                        }),
                        data.usecaseInfo.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, {
                            download: data.usecaseInfo.button.download,
                            href: data.usecaseInfo.button.url,
                            variant: "inverted",
                            demystIcon: true,
                            children: data.usecaseInfo.button.text
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__/* .MainCtaButton */ .T, {})
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,1065,9774,2888,179], function() { return __webpack_exec__(502); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);